import { render, staticRenderFns } from "./ComplianceResourceList.vue?vue&type=template&id=2f7eac87&scoped=true"
import script from "./ComplianceResourceList.vue?vue&type=script&lang=js"
export * from "./ComplianceResourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7eac87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f7eac87')) {
      api.createRecord('2f7eac87', component.options)
    } else {
      api.reload('2f7eac87', component.options)
    }
    module.hot.accept("./ComplianceResourceList.vue?vue&type=template&id=2f7eac87&scoped=true", function () {
      api.rerender('2f7eac87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/resourceManager/ComplianceResourceList.vue"
export default component.exports